<template>
  <div ref="container" class="container">
    <label class="wrapper" :class="{ 'wrapper--invalid': error }">
      <input
        ref="input"
        v-model="internalValue"
        :value="value"
        required
        :disabled="loading"
        type="checkbox"
        class="checkbox-el"
        @change="handleChange"
      />

      <span
        ref="label-basic"
        class="label"
        :class="{ 'label--disabled': loading }"
      >
        <span class="span span--mobile">
          Zapoznałam/łem się z treścią informacji o zasadach przetwarzania
          danych osobowych.
        </span>

        <span class="span span--desktop">
          Zapoznałam/łem się z treścią informacji o zasadach przetwarzania
          danych osobowych.
          <br /><br />
          <ol>
            <li>
              <strong
                >Administratorem danych osobowych jest GRUPA ŻYWIEC Sp. z o.o.
                z&nbsp;siedzibą w&nbsp;Żywcu, przy ul. Browarnej 88, 34-300
                Żywiec</strong
              >, zwana dalej Administratorem.
            </li>
            <li>
              <strong>Kontakt z Administratorem danych</strong> jest możliwy
              poprzez adres e-mail
              <a href="mailto:dane.osobowe@grupazywiec.pl"
                >dane.osobowe@grupazywiec.pl</a
              >
              lub z&nbsp;wykorzystaniem wyżej wskazanego adres
              korespondencyjnego.
            </li>
          </ol>
        </span>

        <button
          class="button"
          @click.prevent="$emit('toggleAgreement', true)"
          v-text="'Rozwiń'"
        />
      </span>
    </label>

    <div class="error">
      <error :error="error" checkbox />
    </div>

    <div ref="overlay" class="overlay" />
  </div>
</template>

<script>
import Error from './Error'

export default {
  components: {
    Error
  },
  props: {
    value: {
      type: [Boolean, Array],
      default: false
    },
    errors: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      internalValue: false
    }
  },
  computed: {
    error() {
      return this.errors[0] ? this.errors[0] : ''
    }
  },
  watch: {
    value: {
      handler(value) {
        this.internalValue = value
      },
      immediate: true
    }
  },
  methods: {
    handleChange() {
      this.$refs.input.blur()
      this.$emit('change')
      this.$emit('input', this.internalValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  z-index: z(checkbox-container);
}

.wrapper {
  display: block;
  width: 100%;

  background-color: $background-color;
}

.checkbox-el {
  @include checkbox-el;
}

.label {
  @include checkbox-label;
}

.button {
  @include extend-button;

  margin: 8px 0 16px;

  &::after {
    width: 56px;
    height: 1px;

    @include media-down(xl) {
      width: 46px;
    }
    @include media-down(lg) {
      width: 65px;
    }
    @include media-down(md) {
      width: 56px;
    }
  }
}

.span {
  @include checkbox-span;
}
</style>
